// extracted by mini-css-extract-plugin
export default {"container":"Table_container__j7mWV","table":"Table_table__jFmf9","tableItem__options":"Table_tableItem__options__sbPrm","loader":"Table_loader__Vty4e"};